import { Card, Typography } from "@mui/material";
// import styled from "@mui/material/styles/styled";
import { styled } from "@mui/material/styles";
import FieldShow from "../../unit/FieldShow";
import formatDate from "../../unit/formatDate";
import HmSubHeaderTitle from "../../unit/HmSubHeaderTitle";
import CustomAsideCard from "../../unit/CustomAsideCard";
import CustomersStageStatus from "./CustomersStageStatus";

const CustomerBaseDataAside = ({ ...props }) => {
  const paramAppId = props.userId;
  let userId = paramAppId;
  let record = props.record;
  if (record == undefined || record == null) {
    return <Typography>N/A</Typography>;
  }

  return (
    <>
      <CustomAsideCard
        sx={{ p: 1, mt: 1 }}
        id={"aside-customer-summary-" + userId}
      >
        <HmSubHeaderTitle title={`User ` + userId} />
        <CustomersStageStatus record={record} userId={userId} />
        <FieldShow
          title="Email"
          value={record.sEmail}
          link={`mailto:${record.sEmail}`}
        />
        <FieldShow title="First Name" value={record.firstname} />
        <FieldShow title="Middle Name" value={record.middlename} />
        <FieldShow title="Last Name" value={record.lastname} />
        <FieldShow
          title="Date of Birth"
          value={record.sBirth}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="SSN"
          value={record?.idtype == "ssn" ? record.sSSN : ""}
          fontFamily="numberFontFamily"
        />
        <hr />
        <FieldShow
          title="Driver's License"
          value={record?.idtype == "driver" ? record.driverId : ""}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Passport ID"
          value={
            record?.idtype == "non-usa-passport" ? record.nonus_passport : ""
          }
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Green Card"
          value={record?.idtype == "greencard" ? record.greencard : ""}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Other ID"
          value={
            record?.idtype != "ssn" &&
            record?.idtype != "driver" &&
            record?.idtype != "greencard" &&
            record?.idtype != "nonus_passport" &&
            record?.idtype != "non-usa-passport"
              ? record.sSSN
              : ""
          }
          fontFamily="numberFontFamily"
        />
        <hr />
        <FieldShow title="Address" value={record?.sAddress} />
        {record?.sAddress2 && (
          <FieldShow title="Address 2" value={record?.sAddress2} />
        )}
        <FieldShow
          title=""
          value={record.sCity + ` ` + record.sState + ` ` + record.sZip}
        />
        <FieldShow
          title="Mobile"
          value={record.sMobile}
          fontFamily="numberFontFamily"
        />
        <FieldShow title="Employer" value={record.employer} />
        <hr />
        <FieldShow title="Sign In Channel" value={record.sCouponCode} />
        <FieldShow
          title="Account Activated"
          value={record ? record.verify_time : ""}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Last Log in"
          value={record ? record.last_login_time : ""}
          fontFamily="numberFontFamily"
        />
        <FieldShow
          title="Last Score Calc"
          value={
            record?.plaidAccount
              ? formatDate(record?.plaidAccount?.calculated_time)
              : ""
          }
          fontFamily="numberFontFamily"
        />
      </CustomAsideCard>
    </>
  );
};

export default CustomerBaseDataAside;
